import {useEffect} from 'react';
import {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useLocation, useNavigate} from 'react-router-dom'
import {getDepotList, getDetail, update} from '../../../../service/admin/data-group/dataGroupServices';
import {toInteger} from 'lodash';
import {message} from "antd";

function useEditDataGroup() {

    const _ = require("lodash")

    const {token} = useSelector(
        (state) => state.auth
    );
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();

    const [data, setData] = useState({});
    const [tab1, setTab1] = useState(true);
    const [tab2, setTab2] = useState(false);
    const [loading, setLoading] = useState(true);
    const [id, setId] = useState("");
    const [name, setName] = useState("");
    const [desc, setDesc] = useState("");
    const [depotIdList, setDepotIdList] = useState([])
    const [updatedAt, setUpdatedAt] = useState('')

    const [dataGroupNameError, setDataGroupNameError] = useState(false)
    const [descriptionError, setDescriptionError] = useState(false)
    const [depotListError, setDepotListError] = useState(false)
    const [depotListCount, setDepotListCount] = useState(0)

    const [depotList, setDepotList] = useState({})
    const [flag, setFlag] = useState()

    const [successModalOpen, setSuccessModalOpen] = useState(false)
    const [userManagementOpen, setUserManagementOpen] = useState(false)
    const [failedModalOpen, setFailedModalOpen] = useState(false);
    const [failedMessages, setFailedMessages] = useState("");

    const getDetailDataGroup = async () => {
        try {
            const response = await getDetail(token, null, location?.state?.id, dispatch);
            if (response && response.ok) {
                setData(response?.data);
                doGetDepotList(response?.data)
            }
        } catch (error) {
            return error;
        }
    }

    const doGetDepotList = async (data) => {
        try {
            const res = await getDepotList(token, null, dispatch)
            if (res.ok) {
                initiateData(data, res?.data.length);
            }
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        getDetailDataGroup()
    }, []);

    const initiateData = (data, countData) => {
        setId(data?.id)
        setName(data?.data_group_id)
        setDesc(data?.description)
        setUpdatedAt(data?.updated_at)
        setDepotListCount(countData)
        setDepotIdList(data?.scope_depot_id.map(item => ({
            id: item.id,
            value: item.name
        })))
        setDepotList({
            flagCheckAll: (depotIdList.length !== 0 && depotListCount !== 0) && depotIdList.length === depotListCount ? true : false,
            isExclude: false,
            data: data?.scope_depot_id.map(item => ({
                id: item.id,
                value: item.name
            }))
        })
        setLoading(false)
    }

    const onChangeTab = (tab) => {
        switch (tab) {
            case 1:
                setTab1(true);
                setTab2(false);
                break;
            case 2:
                setTab1(false);
                setTab2(true);
                break;
            case 3:
                setTab1(false);
                setTab2(false);
                break;

            default:
                break;
        }
    }

    const onChange = (namespace, event) => {
        const value = event
        switch (namespace) {
            case 'dataGroupName':
                if (value !== '') {
                    setName(value)
                    setDataGroupNameError(false)
                } else {
                    setDataGroupNameError(true)
                }
                break;

            case 'description':
                if (value !== '') {
                    setDesc(value)
                    setDescriptionError(false)
                } else {
                    setDescriptionError(true)
                }
                break;

            default:
                break;
        }

    }

    const handleBack = () => {
        const prevPage = location?.state?.prevPage;

        if (prevPage.includes('detail')) {
            navigate(prevPage, {state: {id: location?.state?.id, prevPage}})
        } else {
            navigate(prevPage);
        }
    }

    const onSelected = (data) => {
        let oldDepotIdList = depotIdList


        if (data[1] !== undefined) {
            // console.log(data)
            // console.log(depotList)

            if (_.toInteger(data[1].key) === 0) {
                if (Array.from(oldDepotIdList).some(e => e.id === 0)) {
                    setDepotIdList([])
                    console.log("ada all")
                } else {
                    setDepotIdList([{id: 0, value: "All"}])
                    console.log(oldDepotIdList)
                    console.log("gak ada all")
                }
            } else {

                let found = oldDepotIdList.some(item => item.id === _.toInteger(data[1].key))
                if (found) {
                    let newDepotIdList = oldDepotIdList.filter(object => {
                        return object.id !== _.toInteger(data[1].key)
                    })
                    setDepotIdList(newDepotIdList)
                } else {
                    oldDepotIdList.push({id: _.toInteger(data[1].key), value: data[1].value})
                    setDepotIdList(oldDepotIdList)
                }
            }
        }
    }

    const handleUpdate = async () => {
        let body = {}
        console.log()
        if (flag === 1) {
            setDepotListError(true)
        } else {
            if (flag === 2) {
                body = {
                    data_group_id: name,
                    description: desc,
                    scope_depot_id_list: [-1],
                    updated_at: updatedAt
                }
            } else {
                if (depotIdList.map(item => item.id).includes(0)) {
                    let data = depotIdList.map(item => item.id)
                    let index = data.indexOf(0)
                    data.splice(index, 1)
                    body = {
                        data_group_id: name,
                        description: desc,
                        scope_depot_id_list: data,
                        updated_at: updatedAt
                    }
                } else {
                    body = {
                        data_group_id: name,
                        description: desc,
                        scope_depot_id_list: depotIdList.map(item => item.id),
                        updated_at: updatedAt
                    }
                }
            }
        }

        if (name !== '' && desc !== '' && depotList !== []) {
            try {
                let res = await update(token, null, location?.state?.id, body, dispatch)
                if (res.status) {
                    setSuccessModalOpen(true)
                } else {
                    setFailedModalOpen(true)
                    setFailedMessages(res.message)
                }

            } catch (error) {
                console.log(error)
            }
        }
    }

    const convertTimestamp = (timestamp, isSpecific) => {
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];
        const monthNumbers = ["01", "02", "03", "04", "05", "06",
            "07", "08", "09", "10", "11", "12"
        ];

        // Extract components from the timestamp string
        const year = timestamp?.substring(0, 4);
        const month = timestamp?.substring(5, 7) - 1; // Months in JavaScript are 0-indexed
        const day = timestamp?.substring(8, 10);

        let dateFormat = new Date(year, month, day);

        if (isSpecific) {
            return (`${dateFormat.getDate()}-${monthNames[dateFormat.getMonth()]}-${dateFormat.getFullYear()}`)
        } else {
            return (`${dateFormat.getDate()}/${monthNumbers[dateFormat.getMonth()]}/${dateFormat.getFullYear()}`)
        }
    }

    const _onOk = () => {
        setSuccessModalOpen(false);
        handleBack();
    }

    return {
        handleBack,
        data,
        tab1,
        tab2,
        loading,
        onChangeTab,
        id,
        name,
        desc,
        depotIdList,
        depotList,
        setDepotList,
        flag,
        setFlag,
        setLoading,
        successModalOpen,
        navigate,
        dataGroupNameError,
        descriptionError,
        onChange,
        handleUpdate,
        depotListError,
        depotListCount,
        setDepotIdList,
        onSelected,
        setUserManagementOpen,
        userManagementOpen,
        convertTimestamp,
        _onOk,
        failedMessages,
        failedModalOpen,
        setFailedModalOpen
    }
}

export default useEditDataGroup
